export enum TimeLine {
  Weekly = "common_Weekly",
  Monthly = "common_Monthly",
  AllTime = "common_All Time",
  SpecialEvent = "common_Special Event",
}

export const LIST_TAB_RANK = [
  TimeLine.AllTime,
  TimeLine.Weekly,
  TimeLine.Monthly,
];
